import './assets/styles/main.scss';

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueApollo from 'vue-apollo';
import Meta from 'vue-meta'
import apolloClient from './vue-apollo.js';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'picturefill';
require('intersection-observer');
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents);


Vue.config.productionTip = false;

Vue.use(Meta);
Vue.use(VueApollo);

const ApolloProvider = new VueApollo({
    defaultClient: apolloClient
});

new Vue({
    router,
    store,
    apolloProvider: ApolloProvider,
    render: h => h(App)
}).$mount("#app");
